import { Button } from 'react-bootstrap';
import './LinkButton.css';

const LinkButton = ({
  children,
  onClick,
  disabled = false,
  variant = 'link',
  size = '',
  className = '',
  // Dynamic styling props with defaults
  width = 'fit-content',
  mobileWidth = null, // Width for mobile devices (< 768px)
  height = 'auto',
  padding = '0.4rem 0.6rem',
  fontSize = '14px',
  fontWeight = '600',
  borderRadius = '0',
  backgroundColor = 'transparent',
  borderColor = 'transparent',
  color = 'var(--primary)',
  hoverBackgroundColor = 'transparent',
  hoverBorderColor = 'transparent',
  hoverColor = 'var(--primary-hover)',
  boxShadow = 'none',
  hoverBoxShadow = 'none',
  textDecoration = 'underline',
  hoverTextDecoration = 'underline',
  underlineOffset = '4px',
  transform = 'none',
  hoverTransform = '',
  transition = 'all 0.2s ease',
  ...props
}) => {
  const dynamicStyle = {
    width,
    height,
    padding,
    fontSize,
    fontWeight,
    borderRadius,
    backgroundColor,
    borderColor,
    color,
    boxShadow,
    transform,
    transition,
    textDecoration,
    textUnderlineOffset: underlineOffset,
    // CSS custom properties for hover states
    '--hover-bg': hoverBackgroundColor,
    '--hover-border': hoverBorderColor,
    '--hover-color': hoverColor,
    '--hover-shadow': hoverBoxShadow,
    '--hover-transform': hoverTransform,
    '--hover-text-decoration': hoverTextDecoration,
    // Mobile width
    '--mobile-width': mobileWidth || width,
    ...props.style
  };

  return (
    <Button
      className={`link-btn ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      size={size}
      style={dynamicStyle}
      {...(({ style, ...rest }) => rest)(props)}
    >
      {children}
    </Button>
  );
};

export default LinkButton;
